import { call, select } from 'redux-saga/effects'
import { action as apiAction } from 'api/Api'
import sweetalert from 'sweetalert2'

export default function * requestRemoveUserOwnerFromUserGroup (action) {
  const { userId, userGroupId } = action.payload

  try {
    yield call(apiAction, 'RemoveUserOwningGroup', {
      groupId: userGroupId,
      owningUserId: userId,
    })
  } catch (error) {
    if (error.code !== 401) { // Not found
      if (error.code === 507) { // "KanBo Exception: Can't remove last owner for this group"
        const state = yield select()

        try {
          yield call(sweetalert, {
            text: state.kanbo.locale.messages['USER_GROUP_OWNERS_REMOVE_LAST_OWNER_ERROR'],
            type: 'info'
          })
        } catch (e) {}
      } else {
        throw error
      }
    }
  }
}
